
import { useEffect, useMemo, useState } from 'react';
import styles from './ContactFormBlock.module.css';
import { Each } from '../common/Each'
import TextInput from './TextInput';
import Button from './Button';
import CheckBox from './Checkbox';
import api from '../api';
import { ButtonStatus } from '../common/constants';
import AlertDialog from './dialogs/AlertDialog';
import { DialogStatus } from '../enums';

const ContactFormBlock = ({ data }) => {

    const [payload, setPayload] = useState({});
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const sendForm = async () => {
        setSending(true);
        try {
            await api.post('/forms', { content: payload, ac_lists: data?.ac_lists || [] });
            setSent(true);
        }
        catch (err) {
            console.error('Error sending form', err);
        }
        setSending(false);
    }

    const sendDisabled = useMemo(() => {
        if (!data || !data.fields) return true;
        // per ogni campo di data.fields, se è segnato come required, controlla che esista in payload e che non sia vuoto
        for (let field of data.fields) {
            if (field.required) {
                if (!(field.name in payload)) return true;
                const value = payload[field.name];
                if (field.type === 'checkbox') {
                    if (value !== true) return true;
                } else {
                    if (!value || value.toString().trim() === '') return true;
                }
            }
        }
        return false;
    }, [payload, data]);

    useEffect(() => {
        if (sent) {
            setPayload({});
            const timer = setTimeout(() => {
                setSent(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [sent]);

    return (
        <div className={styles.container}>
            {data && data.fields &&
                <>
                    <Each of={data.fields.sort((a, b) => (a.position ?? 0) - (b.position ?? 0))} render={(field, index) => {
                        return (
                            <div className={`${styles.fieldWrapper} ${styles[field.type]}`} >
                                {field.type === 'text' &&
                                    <TextInput placeholder={field.placeholder} type="text" value={payload[field.name] || ''} key={index} onKeyUp={(value) => {
                                        setPayload((prev) => {
                                            prev[field.name] = value
                                            return { ...prev };
                                        })
                                    }} />
                                }
                                {field.type === 'textarea' &&
                                    <textarea className={styles.textArea} placeholder={field.placeholder} value={payload[field.name] || ''} key={index} onChange={(e) => {
                                        const value = e.target.value;
                                        setPayload((prev) => {
                                            prev[field.name] = value
                                            return { ...prev };
                                        })
                                    }} />
                                }
                                {field.type === 'checkbox' &&
                                    <CheckBox labelStyle={{ fontSize: '0.75rem', opacity: 0.7 }} labelPosition='end' label={field.label} value={payload[field.name] || false} onChange={(value) => {
                                        setPayload((prev) => {
                                            prev[field.name] = value
                                            return { ...prev };
                                        })
                                    }} />
                                }
                            </div>
                        )
                    }} />
                    <div className={styles.action}>
                        <Button onClick={sendForm} disabled={sending || sendDisabled} status={sending ? ButtonStatus.Loading : null}>{data?.send || 'INVIA'}</Button>
                    </div>
                    <AlertDialog status={DialogStatus.Success} title='Richiesta Inviata' text='Richiesta inviata correttamente.' open={sent} onClose={() => { setSent(false) }} />
                </>
            }
        </div>
    )

}

export default ContactFormBlock;